import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Perk } from 'src/app/interfaces/perk';
import { User } from 'src/app/interfaces/user';

@Component({
  selector: 'app-perk-terms',
  templateUrl: './perk-terms.component.html',
  styleUrls: ['./perk-terms.component.scss'],
})
export class PerkTermsComponent implements OnInit {
  perks: Array<Perk>;
  selectedPerk: any;
  user: User;

  constructor(private route: ActivatedRoute) {
    this.user = this.route.snapshot.data.user as User;
    this.perks = this.route.snapshot.data.perks as Array<Perk>;
    // TODO: Get the terms and conditions from the perks endpoint once it's ready on the back-end
    this.route.fragment.subscribe((fragment: string) => {
      this.selectedPerk = !!fragment ? fragment : '';
    });
  }

  hasPerk(name: string): boolean {
    return this.perks.some((p) => p.name === name);
  }

  getPerk(name: string): Perk {
    return this.perks.find((p) => p.name === name);
  }

  ngOnInit(): void {}
}
